import { Card, CardBody, Col } from 'reactstrap'
import { fontSideData, fontSize } from '../../../../Data/Ui-Kits/HelperClasses/HelperClassesData'
import { FontSizes } from '../../../../utils/Constant'
import CommonCardHeader from '../../../../CommonElements/CommonCardHeader/CommonCardHeader'

const FontSizesCart = () => {
  return (
    <Col xs="12">
      <Card>
        <CommonCardHeader title={FontSizes} span={fontSize} headClass="card-no-border pb-0"/>
        <CardBody>
          <div className="gradient-border">
            <div className="font-wrapper border">
              <div className="f-14">Font-size .$f-14</div>
            </div>
            {fontSideData.map((item, index) => (
              <div className="font-wrapper border" key={index}>
                <div className={item}>{`Font-size .${item}`}</div>
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

export default FontSizesCart